import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Image } from '@thd-olt-component-react/image';
import '../../styles/preferred-pricing.style.scss';

const getPreferredPricingDetails = () => {
  return (
      <div>
        <span>
            As a Pro Xtra Customer, you are qualified for our&nbsp;
            <a className="u__default-link" href="https://www.homedepot.com/c/pro_preferred_pricing">Preferred Pricing Program</a>
            .
        </span>
      </div>
  );
}

export const PreferredPricingBadge = (props) => {

  const [disableHoverTooltip, setDisableHoverTooltip] = useState(false);

  const { channel, showPreferredPricingBadgeToolTip } = props;

  const isMobile = channel === 'mobile';

  const preferredPricingDetails = getPreferredPricingDetails();

  return (
    <div className="preferred-pricing__wrapper">
      <div>
        <Image className="preferred-pricing__badge" asset="PreferredPricing-badge.svg" alt="Preferred Pricing Badge" title="Preferred Pricing" />
      </div>
      {showPreferredPricingBadgeToolTip && (
        <div className="preferred-pricing__details">
        {isMobile && (
          <Tooltip
            channel={channel}
            content={preferredPricingDetails}
            interactive
          >
            <Image
              className="preferred-pricing__info-icon"
              asset="info.svg"
              alt="preferred pricing info icon"
            />
          </Tooltip>
        )}
        {!isMobile && (
          <Tooltip
            channel={channel}
            content={preferredPricingDetails}
            interactive
            maxWidth={300}
            disableTooltip={disableHoverTooltip}
            placement="top"
          >
            <div>
              <Tooltip
                channel={channel}
                closeButton
                content={preferredPricingDetails}
                interactive
                maxWidth={320}
                visible={disableHoverTooltip}
                placement="top"
              >
                <div>
                  <Image
                    className="preferred-pricing__info-icon"
                    asset="info.svg"
                    alt="preferred pricing info icon"
                    onClick={() => setDisableHoverTooltip(!disableHoverTooltip)}
                    onClose={() => setDisableHoverTooltip(false)}
                  />
                </div>
              </Tooltip>
            </div>
          </Tooltip>
        )}
      </div>
      )}
    </div>
  );
};

PreferredPricingBadge.propTypes = {
  channel: PropTypes.string.isRequired,
};

PreferredPricingBadge.defaultProps = {};